<template>
<div>
  <div class="loadingContainer" v-if="loadingContainer.remind">
    <div class="loadingContainer_icon">
      <i class="el-icon-loading loadingContainer_icon_loading" v-if="loadingContainer.remind === '表格渲染中。。。'" />
      <i class="el-icon-error loadingContainer_icon_error" v-else />
    </div>
    <div class="loadingContainer_remind">
      <p>{{loadingContainer.remind}}</p>
    </div>
  </div>
  <div v-else>

    <easyCruds :tableInfo="mainTable" ref="mainTable" @view="view" @batchAudit="batchAudit" @exportData="exportData" @doTask="doTask" @mainTableReload="mainTableReload">
      <template slot="taskExeTimeRange" slot-scope="{data}">
            <el-row style="height:39px;overflow: hidden;">
              <el-col :span="7" style="margin-bottom:0;">
                <el-select v-model="data.taskExeTimeRange_link" placeholder="请选择执行环节">
                  <el-option
                    v-for="item in dicData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="5" style="margin-bottom:0;">
                <el-select v-model="data.taskExeTimeRange_unit" style="width: 90%!important" placeholder="请选择执行时间单位">
                  <el-option
                    v-for="item in [
                      {label:'分钟',value:'minute'},
                      {label:'小时',value:'hour'},
                      {label:'天',value:'day'},
                      ]"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="6" style="margin-bottom:0;">
                <el-input-number :min="0" controls-position="right" style="width: 90%" v-model="data.taskExeTimeRange_time_1"></el-input-number>
                -
              </el-col>
              <el-col :span="6" style="margin-bottom:0;">
                <el-input-number :min="1" controls-position="right" style="width: 90%" v-model="data.taskExeTimeRange_time_2"></el-input-number>
              </el-col>
            </el-row>
      </template>
  </easyCruds>
  <batchReview
  :extButtonList="extButtonList"
  :taskFormPropertyList="taskFormPropertyList"
  :batchReview="batchReview"
  :selectionList="selectionList"
  @handleSubmit="handleSubmit" />
  </div>
  </div>
</template>

<script>
import batchReview from '../component/batchReview'
import { tempColDealWith } from '@/workFlow/utils/selectData'
import { initParams, initFixedCondition } from '@/workFlow/utils/params'
import mixExtBtns from '../../dataStatistics/component/mixExtBtns'
export default {
  mixins: [mixExtBtns],
  props: ['dicData', 'formId', 'queryMap', 'tableComment'],
  data() {
    const queryParams = initParams(this.$route.query)
    return {
      criticalPoint: 1,
      queryParams,
      selectionList: [],
      batchReview: {
        show: false,
        options: {},
        modeldata: {},
        showSelectList: false,
        isSign: false,
        batchAuditReferMap: {
          globalParam: {
            showTable: false,
            showDivider: false,
            showCaption: false,
            showIframe: false,
            fullscreen: false
          },
          divider: {},
          extTable: {},
          iframe: {},
          caption: {}
        }
      },
      // 加载容器控制器
      loadingContainer: {
        remind: '表格渲染中。。。'
      },
      // 流程key
      processDefinitionKey: '',
      // 表单ID
      // formId: '',
      // 环节加载框
      // dicData: [],
      // 动态搜索条件map
      // queryMap: null,
      // 导出条件零时存储
      fixedConditionList: [],
      formQueryModelList: [],
      mainTable: {
        buttonSetting: {
          allowAdd: false,
          allowEdit: false,
          allowView: false,
          allowDelete: false,
          left: [{
            title: '导出数据',
            type: 'primary',
            clickEvent: 'exportData'
          }, {
            title: '批量审核',
            type: 'success',
            clickEvent: 'batchAudit'
          }]
        },
        table: {
          loading: false,
          stripe: true,
          conditionLabelWidth: 'auto',
          selection: true,
          index: true,
          columns: [],
          operation: {
            width: '100',
            operations: [{
              clickEvent: 'view',
              title: '查看'
            }, {
              clickEvent: 'doTask',
              title: '办理'
            }]
          },
          tableData: [],
          paging: {
            currentPage: 1,
            pageSizes: [15, 20, 25, 30],
            pageSize: 15,
            total: 0
          },
          reload: 'mainTableReload',
          reloadConditions: {
            taskExeTimeRange_unit: 'day',
            taskExeTimeRange_link: '',
            ...queryParams
          }
        }
      },
      showCondition: {
        taskExeTimeRange: true,
        procExeTimeRange: true,
        procStartDateTime: true,
        ruTask: true,
        completeStatus: true
      }
    }
  },

  components: { batchReview },

  mounted: function() {
    let { processDefinitionKey, taskExeTimeRange, procExeTimeRange, procStartDateTime, ruTask, completeStatus } = this.$route.query
    if (taskExeTimeRange === 'hide') {
      this.showCondition.taskExeTimeRange = false
    }
    if (procExeTimeRange === 'hide') {
      this.showCondition.procExeTimeRange = false
    }
    if (procStartDateTime === 'hide') {
      this.showCondition.procStartDateTime = false
    }
    if (ruTask === 'hide') {
      this.showCondition.ruTask = false
    }
    if (completeStatus === 'hide') {
      this.showCondition.completeStatus = false
    }
    if (!processDefinitionKey) {
      this.$message.error('未获取到流程Key,请联系管理员')
      this.$router.push('/404')
      return
    } else {
      this.processDefinitionKey = processDefinitionKey
    }
    // this.getLinkDic()
    // this.getQueryConditionsByProcessDefinitionKey(() => {

    // })
    this.getData()
  },
  methods: {
    /**
     * 获取环节下拉列表
     */
    // getLinkDic() {
    //   this.$http.get('/flow-ext/process-task-list', {
    //     params: {
    //       procKey: this.processDefinitionKey,
    //       containHis: false
    //     }
    //   }).then(response => {
    //     debugger
    //     this.dicData = response.data.map(item => ({
    //       label: item.taskName,
    //       value: item.taskDefKey
    //     }))
    //     debugger
    //   }).catch(error => {
    //     this.loadingContainer.remind = error.msg || error.message
    //     this.$message.error(error.msg || error.message)
    //   })
    // },
    /**
     * 根据流程key获取查询条件
     */
    getQueryConditionsByProcessDefinitionKey(callback) {
      this.$http.get('/business-list/query-conditions', {
        params: {
          procDefKey: this.processDefinitionKey
        }
      }).then(response => {
        this.formId = response.data.formId
        let queryMap = new Map()
        const setQueryShowType = (item) => {
          // 精确 查询
          if (item.queryType === 'accurate') {
            if (Array.isArray(item.propJson.dicData)) {
              item.showType = 'select'
            } else {
              item.showType = 'input'
            }
          } else if (item.queryType === 'blurry') {
            // 模糊
            item.showType = 'input'
          } else if (item.queryType === 'timeRange') {
            // 日期时间范围
            item.showType = 'datetimerange'
          } else if (item.queryType === 'dateRange') {
            item.showType = 'daterange'
          } else {
            item.showType = 'input'
          }
          return item
        }
        response.data.formQueryModelList.forEach(item => {
          queryMap.set(item.prop, setQueryShowType(item))
        })
        this.queryMap = queryMap
        callback()
      }).catch(error => {
        this.loadingContainer.remind = error.msg || error.message
        this.$message.error(error.msg || error.message)
      })
    },
    /**
     * 数据查询,顺带返回header
     */
    getData(formQueryModelList) {
      const initFixed = initFixedCondition(this.$route.query, this.queryParams)
      this.$http.post('/business-list/involved-my-proc-todo', {
        fixedConditionList: initFixed,
        formQueryModelList: []
      }, {
        params: {
          formId: this.formId,
          pageNum: 1,
          pageSize: 15,
          procDefKey: this.processDefinitionKey
        }
      }).then(response => {
        /** 固定条件 环节执行时长 */
        this.mainTable.table.columns.push({
          prop: 'taskExeTimeRange',
          label: '环节执行时长',
          searchSlotName: 'taskExeTimeRange',
          type: 'datetimerange',
          isSearchCondition: this.showCondition.taskExeTimeRange,
          showInTable: false,
          searchSpan_xl: 12,
          searchSpan_md: 12,
          searchSpan_sm: 12,
          searchSpan_lg: 12
        })
        /** 流程创建时间 */
        this.mainTable.table.columns.push({
          prop: 'procStartDateTime',
          label: '创建时间',
          type: 'daterange',
          isSearchCondition: this.showCondition.procStartDateTime,
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd',
          showInTable: false,
          searchSpan_xl: window.scale > this.criticalPoint ? 8 : 6,
          searchSpan_md: window.scale > this.criticalPoint ? 8 : 6,
          searchSpan_sm: window.scale > this.criticalPoint ? 8 : 6,
          searchSpan_lg: window.scale > this.criticalPoint ? 8 : 6
        })
        /** 所处环节 */
        this.mainTable.table.columns.push({
          prop: 'ruTask',
          label: '所处环节',
          type: 'select',
          dicData: this.dicData,
          isSearchCondition: this.showCondition.ruTask,
          showInTable: false,
          searchSpan_xl: 6,
          searchSpan_md: 6,
          searchSpan_sm: 6,
          searchSpan_lg: 6
        })
        let colum = response.data.header.filter(item => item.isShow === 'true')
        colum.forEach(item => {
          let tempCol = {
            prop: item.prop,
            type: item.dataType,
            label: item.label,
            width: 200,
            searchSpan_xl: 6,
            searchSpan_md: 6,
            searchSpan_sm: 6,
            searchSpan_lg: 6
          }
          let queryCondition = this.queryMap.get(item.prop)
          if (queryCondition) {
            tempCol.type = queryCondition.showType
            tempCol.isSearchCondition = true
            if (queryCondition.showType === 'datetimerange') {
              tempCol.searchSpan_xl = window.scale > this.criticalPoint ? 12 : 8
              tempCol.searchSpan_md = window.scale > this.criticalPoint ? 12 : 8
              tempCol.searchSpan_sm = window.scale > this.criticalPoint ? 12 : 8
              tempCol.searchSpan_lg = window.scale > this.criticalPoint ? 12 : 8
              tempCol.format = 'yyyy-MM-dd HH:mm:ss'
              tempCol.valueFormat = 'yyyy-MM-dd HH:mm:ss'
            } else if (queryCondition.showType === 'daterange') {
              tempCol.format = 'yyyy-MM-dd'
              tempCol.valueFormat = 'yyyy-MM-dd'
            }
          }

          const columns = this.mainTable.table.columns
          return tempColDealWith({
            columns,
            propJson: item.propJson,
            tempCol
          })
        })
        this.loadingContainer.remind = ''
        // this.mainTableReload()
        this.mainTable.table.loading = false
        this.mainTable.table.tableData = response.data.businessList.records
        this.mainTable.table.paging.total = response.data.businessList.total
      }).catch(error => {
        this.loadingContainer.remind = error.msg || error.message
        this.$message.error('列表模型加载失败:' + error.msg || error.message)
      })
    },
    view(index, row) {
      row.businessKey = row.id
      this.$router.push({
        name: 'workFlow-view-myApply',
        query: {
          businessKey: row.businessKey,
          processInstanceId: row.processInstanceId,
          taskId: null,
          formId: null,
          pageKey: 'VIEW'
        }
      })
    },
    /**
     *  办理流程
     */
    doTask(index, row) {
      row.businessKey = row.id
      this.$http.get('/flow-ext/process-form-key', {
        params: {
          processInstanceId: row.processInstanceId
        }
      }).then(response => {
        row.taskFormKey = [response.data]
        this.$router.push({
          name: 'workFlow-view-myApply',
          query: {
            businessKey: row.businessKey,
            processInstanceId: row.processInstanceId,
            taskId: row.taskId,
            formId: response.data,
            pageKey: 'DO'
          }
        })
      }).catch(error => {
        this.$message.error(error.msg || error.message)
      })
    },
    mainTableReload(params = {
      pageNum: 1,
      pageSize: 15
    }) {
      let fixedConditionList = []
      let formQueryModelList = []
      /** procStartDateTime 创建时间  */
      if (Array.isArray(params.procStartDateTime) && params.procStartDateTime.length === 2) {
        fixedConditionList.push({
          type: 'procStartDateTime',
          rangeSeachArray: params.procStartDateTime
        })
      }
      /** 环节执行时长组装 taskExeTimeRange */
      let {
        taskExeTimeRange_link,
        taskExeTimeRange_unit,
        taskExeTimeRange_time_1,
        taskExeTimeRange_time_2
      } = params
      if (taskExeTimeRange_link && taskExeTimeRange_unit && (taskExeTimeRange_time_1 === 0 || taskExeTimeRange_time_1) && taskExeTimeRange_time_2) {
        fixedConditionList.push({
          rangeSeachArray: [taskExeTimeRange_time_1, taskExeTimeRange_time_2],
          secondType: taskExeTimeRange_unit,
          type: 'taskExeTimeRange',
          value: taskExeTimeRange_link
        })
      }
      /** ruTask 所处环节 */
      if (params.ruTask) {
        fixedConditionList.push({
          type: 'ruTask',
          value: params.ruTask
        })
      }
      /** 其他动态搜索字段 */
      if (this.queryMap) {
        this.queryMap.forEach(function(item) {
          let value = params[item.prop]
          if ((Array.isArray(value) && value.length === 2) || value) {
            let a = Object.assign({}, item)
            if (Array.isArray(value)) {
              a.searchArray = value
            } else {
              a.searchValue = value
            }
            delete a.propJson
            formQueryModelList.push(a)
          }
        })
      }
      /**  组装 params 参数  */
      // 固定参数
      this.mainTable.table.loading = true
      this.fixedConditionList = fixedConditionList
      this.formQueryModelList = formQueryModelList
      this.$http.post('/business-list/involved-my-proc-todo', {
        fixedConditionList,
        formQueryModelList
      }, {
        params: {
          formId: this.formId,
          pageNum: params.pageNum,
          pageSize: params.pageSize,
          procDefKey: this.processDefinitionKey
        }
      }).then(response => {
        this.mainTable.table.loading = false
        this.mainTable.table.tableData = response.data.businessList.records
        this.mainTable.table.paging.total = response.data.businessList.total
      }).catch(error => {
        this.mainTable.table.loading = false
        this.$message.error('加载数据错误:' + error.msg || error.message)
      })
    },
    exportData() {
      this.$confirm('确定要导出数据吗?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        this.$downloadFile.post('/business-list/involved-my-proc-todo-export', {
          fixedConditionList: this.fixedConditionList,
          formQueryModelList: this.formQueryModelList
        }, {
          params: {
            formId: this.formId,
            procDefKey: this.processDefinitionKey,
            fileName: this.tableComment + '(进行中).xls',
            doDownload: true
          }
        }).then(response => {

        }).catch(error => {
          this.$message.error(error.msg || error.message)
        })
      }).catch(_ => {})
    },
    batchAudit() {
      this.batchReview.showSelectList = false
      this.batchReview.isSign = false
      this.batchReview.batchAuditReferMap = {
        globalParam: {
          showTable: false,
          showDivider: false,
          showCaption: false,
          showIframe: false,
          fullscreen: false
        },
        divider: {
          title: '分割线'
        },
        extTable: {},
        iframe: {
          src: 'http://www.baidu.com',
          height: 200
        },
        caption: {
          value: '文字说明',
          style: 'background: rgba(246, 246, 246, 100);font-size:14px;line-height:22px'
        }
      }

      let selectedRows = this.$refs.mainTable.getSelectedRows()
      this.selectionList = selectedRows
      console.log(selectedRows)
      if (selectedRows.length) {
        // 判断所处环节是否一致
        let taskNameArray = Array.from(new Set(selectedRows.map(item => item.taskName)))
        if (taskNameArray.length !== 1) {
          return this.$message.error(`批量审核只能审核同一流程同一环节下的待办任务,
        你选择的任务中共存在${taskNameArray.length}个环节,包含 ${taskNameArray.toString()}`)
        } else {
          // 这里就可以进行批量审核了
          // 1.请求服务器判断选中的行能否进行批量审核
          this.$http.post('/batch-audit/valid', selectedRows.map(item => ({
            businessKey: item.id,
            taskId: item.taskId
          }))).then(response => {
            // extbtns
            const {
              formModelJsonList,
              taskFormPropertyList,
              batchAuditReferMap
            } = response.data
            this.initBtns(taskFormPropertyList, formModelJsonList[0].extButtonList)

            // 表单模型数据
            let formModelJson = response.data.formModelJsonList[0]
            // 批量审核字段
            let taskFormPropety = response.data.taskFormPropertyList

            // let batchAuditReferMap = response.data.batchAuditReferMap
            if (batchAuditReferMap.globalParam) {
              this.batchReview.batchAuditReferMap.globalParam =
              Object.assign(this.batchReview.batchAuditReferMap.globalParam, batchAuditReferMap.globalParam)
            }
            if (batchAuditReferMap.divider) {
              this.batchReview.batchAuditReferMap.divider =
              Object.assign(this.batchReview.batchAuditReferMap.divider, batchAuditReferMap.divider)
            }
            if (batchAuditReferMap.extTable) {
              this.batchReview.batchAuditReferMap.extTable = batchAuditReferMap.extTable
            }
            if (batchAuditReferMap.iframe) {
              this.batchReview.batchAuditReferMap.iframe =
              Object.assign(this.batchReview.batchAuditReferMap.iframe, batchAuditReferMap.iframe)
            }
            if (batchAuditReferMap.caption) {
              this.batchReview.batchAuditReferMap.caption =
              Object.assign(this.batchReview.batchAuditReferMap.caption, batchAuditReferMap.caption)
            }

            // 需要批量审核的字段
            let column = formModelJson.column.filter(item => item.prop !== 'verifyFlag' && taskFormPropety.some(element => item.prop === element.id))
            column.forEach(item => {
              // item.span = 18
              if (taskFormPropety.some(element => item.prop === element.id && !element.writable && element.readable)) {
                item.disabled = true
              }
            })
            this.batchReview.options = Object.assign(formModelJson, { column })
            if (response.data.formModelJsonList.length > 1) {
              this.batchReview.isSign = true
              this.batchReview.options = response.data.formModelJsonList[1]
            }
            this.batchReview.options.column.forEach((formItem) => {
              // 选出需要绑定 blur事件的组件,其他的全部监听change事件
              let blurComponent = ['input', 'password', 'textarea']
              // 事件对列
              let changeEventQueue = []
              let clickEventQueue = []
              let blurEventQueue = []
              let focusEventQueue = []
              if (formItem.casUrl) {
                let executiveFunction = () => {
                  let bodyData = this.batchReview['modeldata']
                  bodyData['taskDefinitionKey'] = response.data.taskDefinitionKey
                  this.$http
                    .post(`${formItem.casUrl}`, bodyData)
                    .then((response) => {
                      let columnList = response.data.columnList
                      let modifyData = {}
                      columnList.forEach((item) => {
                        if (item.hasOwnProperty('value')) {
                          modifyData[item.prop] = item.value // 记录修改的value值
                        }
                        this.batchReview.options.column
                          .filter((columnItem) => columnItem.prop === item.prop)
                          .forEach((columnItem) => {
                            Object.keys(item).forEach((itemKey) => {
                              this.$set(columnItem, itemKey, item[itemKey]) // 循环修改字段属性
                            })
                            // Object.assign(columnItem, item)// 循环修改字段属性
                          })
                      })
                      // 统一修改数据
                      Object.keys(modifyData).forEach(itemKey => {
                        if (Array.isArray(modifyData[itemKey])) {
                          this.batchReview.modelData[itemKey] = []
                          modifyData[itemKey].forEach(subItem => this.batchReview.modelData[itemKey].push(this.deepClone(subItem)))
                        } else {
                          this.$set(this.batchReview.modelData, itemKey, modifyData[itemKey])
                        }
                      })
                    })
                    .catch((error) => {
                      this.$message.error(error.msg || error.message)
                    })
                }
                blurComponent.includes(formItem.type)
                  ? blurEventQueue.push(executiveFunction)
                  : changeEventQueue.push(executiveFunction)
              }
              // 事件队列写入
              if (changeEventQueue.length) {
                formItem.change = (e) => changeEventQueue.forEach((item) => item(e))
              }
              if (clickEventQueue.length) {
                formItem.click = (e) => clickEventQueue.forEach((item) => item(e))
              }
              if (blurEventQueue.length) {
                formItem.blur = (e) => blurEventQueue.forEach((item) => item(e))
              }
              if (focusEventQueue.length) {
                formItem.focus = (e) => focusEventQueue.forEach((item) => item(e))
              }
            })
            this.batchReview.show = true
          }).catch(error => this.$message.error(error.msg || error.message))
        }
      } else {
        this.$message.error('请选中至少一条数据后在进行操作')
      }
    },
    handleSubmit(data, again) {
      let dataMap = data
      dataMap.verifyFlag = again ? '2' : '1'
      let formId = this.batchReview.options.formId
      let isSign = this.batchReview.isSign
      let businessTaskList = this.$refs.mainTable.getSelectedRows().map(item => ({
        businessKey: item.id,
        taskId: item.taskId,
        processInstanceId: item.processInstanceId
      }))
      const postdata = {
        businessTaskList,
        dataMap,
        formId,
        isSign
      }

      this.$http.post('/batch-audit/do-task', postdata).then(response => {
        // 批量成功
        this.batchReview.show = false
        this.$message.success(response.msg)
        this.$refs.mainTable.reload()
      }).catch(error => {
        if (error.code === 1101) {
          this.$confirm(error.msg, '温馨提示', {
            cancelButtonText: '取消',
            confirmButtonText: '确定',
            type: 'info'
          }).then(() => {
            // 反复确认
            this.handleSubmit(data, true)
          }).catch(error => {
            this.$message(error.msg || error.message)
            this.batchReview.show = false
          })
        } else {
          this.$message.error(error.msg || error.message)
        }
      })
    }

  }
}
</script>

<style lang="scss" scoped>
.loadingContainer {
  width: 500px;
  margin: 0 auto;
  padding: 5px 0;
  color: rgb(59, 156, 217);
  text-align: center;
  font-weight: 600;
  &_icon {
    font-size: 25px;
    &_error {
      color: red;
    }
  }
  &_remind {
    p {
      margin: 0;
      width: 100%;
    }
  }
}
</style>
